const defaultChart = {
  chartName: "Chart",
  chartId: 1,
  chartType: "",
  xAxis: "",
  yAxis: "",
};

export default defaultChart;
